import { Editor } from 'slate';
import { INLINE_LINK } from '../../../types';

export function isLinkActive(editor: Editor) {
  const res = Editor.nodes(editor, { match: n => n.type === INLINE_LINK });
  const marks = Array.from(res);

  return marks.length > 0;
}
